import { render, staticRenderFns } from "./AskForJustificationPolicyScriptModal.vue?vue&type=template&id=6b1cc714&"
import script from "./AskForJustificationPolicyScriptModal.vue?vue&type=script&lang=ts&"
export * from "./AskForJustificationPolicyScriptModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports